<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">
                                    {{ $t('string.msg.system.config.gasstation') }}
                                </h4>
                            </div>
                        </div>
                    </div>
                    <!-- Form row -->
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card-box">
                                <p class="sub-header">
                                    {{ $t('string.msg.user.label.data.gas.station.decription') }}
                                </p>
                                <form>
                                    <div class="form-row" v-if="data._id">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.product.brand.label.id') }}
                                            </label>
                                            <input type="text" readonly v-model="data._id" class="form-control" />
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.status') }}
                                            </label>
                                            <select v-model="data.status" class="form-control">
                                                <option :value="null" selected>
                                                    {{ $t('string.msg.element.select.selectitem') }}
                                                </option>
                                                <option value="ACTIVE">
                                                    {{ $t('string.msg.active') }}
                                                </option>
                                                <option value="ARCHIVED">
                                                    {{ $t('string.msg.archived') }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.fantasyName') }}
                                            </label>
                                            <input type="text" v-model="data.fantasyName" class="form-control" :placeholder="$t('string.msg.company.placeholder.fantasyName')" />
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.socialName') }}
                                            </label>
                                            <input type="text" v-model="data.socialName" class="form-control" :placeholder="$t('string.msg.company.placeholder.socialName')" />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.document') }}
                                            </label>
                                            <input
                                                type="tel"
                                                v-model="data.document"
                                                v-mask="['###.###.###-##', '##.###.###/####-##']"
                                                class="form-control"
                                                :placeholder="$t('string.msg.company.placeholder.document')"
                                            />
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{ $t('string.msg.company.label.stateSubscription') }}
                                            </label>
                                            <input
                                                v-model="data.stateSubscription"
                                                type="text"
                                                class="form-control"
                                                :placeholder="$t('string.msg.company.placeholder.stateSubscription')"
                                                v-mask="['###.###.###.###']"
                                            />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code v-if="!data._id" class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.primaryPhone') }}
                                            </label>
                                            <input
                                                v-model="data.primaryPhone"
                                                type="text"
                                                class="form-control"
                                                :placeholder="$t('string.msg.company.placeholder.primaryPhone')"
                                                v-mask="['(##) ####-####', '(##) #####-####']"
                                            />
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code v-if="!data._id" class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.main.email') }}
                                            </label>
                                            <input type="text" v-model="data.email" class="form-control" :placeholder="$t('string.msg.company.placeholder.main.email')" />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{ $t('string.msg.company.label.secondaryPhone') }}
                                            </label>
                                            <input
                                                v-model="data.secondaryPhone"
                                                type="text"
                                                class="form-control"
                                                :placeholder="$t('string.msg.company.placeholder.primaryPhone')"
                                                v-mask="['(##) ####-####', '(##) #####-####']"
                                            />
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{ $t('string.msg.company.label.talkto') }}
                                            </label>
                                            <input v-model="data.talkTo" type="text" class="form-control" :placeholder="$t('string.msg.company.placeholder.talkto')" />
                                        </div>
                                    </div>

                                    <!-- <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.isbranch') }}
                                            </label>
                                            <select v-model="data.isBranch" class="form-control">
                                                <option :value="false">
                                                    {{ $t('string.msg.no') }}
                                                </option>
                                                <option :value="true">
                                                    {{ $t('string.msg.yes') }}
                                                </option>
                                            </select>
                                        </div>

                                        <div v-if="data.isBranch == true" class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.document.main') }}
                                            </label>
                                            <input type="tel" v-mask="'##.###.###/####-##'" v-model="data.mainCompany" class="form-control" :placeholder="$t('string.msg.company.placeholder.document')" />
                                        </div>
                                    </div> -->

                                    <div class="form-row">
                                        <div class="form-group col-md-12">
                                            <label for="inputAddress" class="col-form-label">
                                                {{ $t('string.msg.company.label.address') }}
                                            </label>
                                            <vue-google-autocomplete
                                                ref="address"
                                                id="map"
                                                v-model="data.locale.address"
                                                classname="form-control"
                                                placeholder="Digite o endereço"
                                                v-on:placechanged="getAddressData"
                                            >
                                            </vue-google-autocomplete>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{ $t('string.msg.company.geolocation.lat') }}
                                            </label>
                                            <input v-model="data.locale.geolocation.latitude" type="text" class="form-control" :placeholder="$t('string.msg.company.geolocation.lat')" />
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{ $t('string.msg.company.geolocation.lng') }}
                                            </label>
                                            <input v-model="data.locale.geolocation.longitude" type="text" class="form-control" :placeholder="$t('string.msg.company.geolocation.lng')" />
                                        </div>
                                    </div>

                                    <div id="accordionService" v-if="tags && tags.length > 0">
                                        <div class="card">
                                            <div class="card-header" id="headingTwoService">
                                                <h5 class="mb-0">
                                                    <span class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwoService" aria-expanded="true" aria-controls="collapseTwoService">
                                                        {{ $t('string.msg.companies.list.tags.label') }}
                                                    </span>
                                                </h5>
                                            </div>

                                            <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <div id="collapseTwoService" class="collapse show" aria-labelledby="headingTwoService" data-parent="#accordionService">
                                                        <div class="card-body">
                                                            <div class="d-flex flex-wrap">
                                                                <div class="container-switch" v-bind:key="item.id" v-for="item in tags">
                                                                    <label class="switch">
                                                                        <input v-model="data.tags" type="checkbox" :id="item._id" :value="item._id" :true-value="item._id" :false-value="null" />
                                                                        <span class="slider round"></span>
                                                                    </label>
                                                                    <span class="label-swith">{{ camelize($t(item._id)).split('ZZZ_').join('') }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div id="accordionFuel" v-if="tags && tags.length > 0">
                                        <div class="card">
                                            <div class="card-header" id="headingFuel">
                                                <h5 class="mb-0">
                                                    <span class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFuel" aria-expanded="true" aria-controls="collapseFuel">
                                                        {{ $t('string.msg.companies.fuels.price.label') }}
                                                    </span>
                                                </h5>
                                            </div>

                                            <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <div id="collapseFuel" class="collapse show" aria-labelledby="headingFuel" data-parent="#accordionFuel">
                                                        <div class="card-body">
                                                            <div class="flex-wrap">
                                                                <div class="form-row">
                                                                    <div class="form-group col-md-3">
                                                                        <label for="inputAddress" class="col-form-label">
                                                                            {{ $t('string.msg.fuel.gnv') }}
                                                                        </label>
                                                                        <input v-model="data.fuels.gnv" v-money="money" type="text" id="gnv" class="form-control" />
                                                                    </div>
                                                                    <div class="form-group col-md-3">
                                                                        <label for="inputAddress" class="col-form-label">
                                                                            {{ $t('string.msg.fuel.gas') }}
                                                                        </label>
                                                                        <input v-model="data.fuels.gas" v-money="money" type="text" id="gas" class="form-control" />
                                                                    </div>
                                                                    <div class="form-group col-md-3">
                                                                        <label for="inputAddress" class="col-form-label">
                                                                            {{ $t('string.msg.fuel.premmiumGas') }}
                                                                        </label>
                                                                        <input v-model="data.fuels.premmiumGas" v-money="money" type="text" id="premmiumGas" class="form-control" />
                                                                    </div>
                                                                    <div class="form-group col-md-3">
                                                                        <label for="inputAddress" class="col-form-label">
                                                                            {{ $t('string.msg.fuel.additiveGas') }}
                                                                        </label>
                                                                        <input v-model="data.fuels.additiveGas" v-money="money" type="text" id="additiveGas" class="form-control" />
                                                                    </div>
                                                                </div>
                                                                <div class="form-row">
                                                                    <div class="form-group col-md-3">
                                                                        <label for="inputAddress" class="col-form-label">
                                                                            {{ $t('string.msg.fuel.ethanol') }}
                                                                        </label>
                                                                        <input v-model="data.fuels.ethanol" v-money="money" type="text" id="ethanol" class="form-control" />
                                                                    </div>
                                                                    <div class="form-group col-md-3">
                                                                        <label for="inputAddress" class="col-form-label">
                                                                            {{ $t('string.msg.fuel.premmiumEthanol') }}
                                                                        </label>
                                                                        <input v-model="data.fuels.premmiumEthanol" v-money="money" type="text" id="premmiumEthanol" class="form-control" />
                                                                    </div>
                                                                    <div class="form-group col-md-3">
                                                                        <label for="inputAddress" class="col-form-label">
                                                                            {{ $t('string.msg.fuel.diesel') }}
                                                                        </label>
                                                                        <input v-model="data.fuels.diesel" v-money="money" type="text" id="diesel" class="form-control" />
                                                                    </div>
                                                                    <div class="form-group col-md-3">
                                                                        <label for="inputAddress" class="col-form-label">
                                                                            {{ $t('string.msg.fuel.dieselS10') }}
                                                                        </label>
                                                                        <input v-model="data.fuels.dieselS10" v-money="money" type="text" id="dieselS10" class="form-control" />
                                                                    </div>
                                                                </div>
                                                                <div class="form-row">
                                                                    <div class="form-group col-md-3">
                                                                        <label for="inputAddress" class="col-form-label">
                                                                            {{ $t('string.msg.fuel.dieselS500') }}
                                                                        </label>
                                                                        <input v-model="data.fuels.dieselS500" v-money="money" type="text" id="dieselS500" class="form-control" />
                                                                    </div>
                                                                    <div class="form-group col-md-3">
                                                                        <label for="inputAddress" class="col-form-label">
                                                                            {{ $t('string.msg.fuel.electricity') }}
                                                                        </label>
                                                                        <input v-model="data.fuels.electricity" v-money="money" type="text" id="electricity" class="form-control" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">{{ $t('string.msg.gas.stations.label.logo') }} </label>
                                            <input type="file" id="banner" ref="file" v-on:change="handleFileUpload()" class="form-control" />
                                        </div>
                                        <div class="form-group col-md-6">
                                            <img v-if="data.logoURL" style="object-fit: contain" v-bind:src="`${domain}${data.logoURL}`" alt="image" height="200" width="400" />
                                        </div>
                                    </div>

                                    <div v-if="errors.length" class="alert alert-danger">
                                        <p class="lead">
                                            {{ $t('response.msg.error.empty.fields') }}
                                        </p>
                                        <ul>
                                            <li v-bind:key="error" v-for="error in errors">
                                                {{ error }}
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="mt-4 form-row text-center">
                                        <div class="form-group col-md-6">
                                            <button @click="clearForm" class="btn btn-secondary w-50">
                                                {{ $t('string.msg.form.btn.clear') }}
                                            </button>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <button @click="checkForm" class="btn btn-danger w-50">
                                                {{ $t('string.msg.form.btn.save') }}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                                <!-- {{ data }} -->
                            </div>
                        </div>
                    </div>
                    <List v-on:load-item="selectItem" />
                </div>
            </div>
        </div>
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <Confirmation :title="titleToast" :message="messageToast" :cancelText="cancelText" :yesText="yesText" v-on:confirmation-return="archive" />
        <FlashMessage />
    </div>
</template>

<script>
import Controller from './CrtGasStation'
import List from './ListGasStation'
import Spinner from '../../../components/layout/Spinner'
import Toast from '../../../components/layout/Toast'
import Confirmation from '../../../components/layout/Confirmation'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import Vue from 'vue'

Vue.prototype.$eventHub = new Vue()
export default {
    name: 'GasStation',
    props: ['valuekey'],
    watch: {
        valuekey() {},
    },
    components: {
        Spinner,
        Toast,
        List,
        Confirmation,
        VueGoogleAutocomplete,
    },
    data() {
        return {
            errors: [],
            addresses: [],
            certifies: [],
            tags: [],
            titleToast: null,
            messageToast: null,
            messageIdToast: null,
            manufacturers: [],
            families: [],
            lastDocument: null,
            file: null,
            data: {
                status: 'ACTIVE',
                isBranch: false,
                fantasyName: null,
                socialName: null,
                email: null,
                document: null,
                photoURL: 'https://',
                locale: {
                    address: null,
                    geolocation: {
                        latitude: null,
                        longitude: null,
                    },
                },
                tags: [],
                fuels: {
                    gnv: null,
                    gas: null,
                    premmiumGas: null,
                    additiveGas: null,
                    ethanol: null,
                    premmiumEthanol: null,
                    diesel: null,
                    dieselS10: null,
                    dieselS500: null,
                    electricity: null,
                },
                primaryPhone: null,
                secondaryPhone: null,
                talkTo: null,
                typeService: ['GAS_STATION'],
            },
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false,
                min: 0,
                max: 999,
            },
        }
    },
    methods: Controller.methods,
    created() {},
    mounted() {
        Controller.init(this)
    },
}
</script>

<style>
</style>
